import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../../components/app/Logo";

export function AuthFrame({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <div className="grid min-h-screen bg-slate-50 px-4 py-8">
      <div className="mx-auto w-full max-w-md self-center">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-panel">
          <h1 className="text-2xl font-bold text-navy-950">{title}</h1>
          <p className="mt-2 text-sm text-slate-600">{subtitle}</p>
          <div className="mt-6">{children}</div>
        </div>
        <p className="mt-6 text-center text-sm text-slate-500">
          <Link className="font-medium text-navy-900 hover:underline" to="/">
            Back to BaselineBoard.app
          </Link>
        </p>
      </div>
    </div>
  );
}
